export const measurementClasses: any = {
    BackgroundPercentage: "Background",
    BackgroundMucinPercentage: "Mucin",
    LymphocyteInfiltrateClusterPercentage: "Lymphocyte Infiltrate Cluster",
    LymphocyteInfiltratePercentage: "Lymphocyte Infiltrate",
    MacrophagePercentage: "Macrophage",
    NecrosisPercentage: "Necrosis",
    StromaPercentage: "Stroma",
    TumorPercentage: "Tumor",
    TumorGhostPercentage: "Tumor Ghost",
    UnknownPercentage: "Unknown",
}